import React from "react";
import { IconT } from "types/utils";

const FolderOutlineIcon = ({ height = "17", width = "17", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none" aria-hidden>
      <path
        d="M2.75 5.25h5l1.5 1.5h8v8.5h-14.5v-10Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default FolderOutlineIcon;
